import React, { PureComponent, PropTypes } from 'react';

import { connect } from 'react-redux';
import { loadNewsPage } from '../../redux/actions';
import { selectHydrated } from '../../redux/modules/news/selectors';
import List from '../../components/List';
import { verboseDate } from '../../utils/date';


class NewsIndex extends PureComponent {
  static propTypes = {
    parent: PropTypes.any,
    items: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    pageCount: PropTypes.number,
    nextPageUrl: PropTypes.string,
    loadNewsPage: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.props.loadNewsPage();
  }

  handleLoadMoreClick = () => {
    this.props.loadNewsPage(this.props.nextPageUrl);
  }

  goToDetails = (id) => {
    const { history } =  this.props;
    history.push(`/news/${id}/`);
  }

  renderItem = ({id, title, thumb, publishAt }) => {
    const cls = this.props.parent? "col-12 item" : "col-sm-12 col-md-6 col-lg-4 item";
    return (
      <div className={cls} key={id}>
        <div>
          <img className="mb-3" src={thumb} alt={title} onClick={_ => this.goToDetails(id)} />
          <div className="media-body">
            <span className="date">{verboseDate(publishAt)}</span>
            <h3 onClick={_ => this.goToDetails(id)}>{title}</h3>
          </div>
        </div>
      </div>
    )
  }


  render() {
    const { parent, items, ...props } = this.props;

    return (
      <div>
        {parent
          ? (<h3 className="mb-4">Citi Jaunumi</h3>)
          : (<h1 className="mb-4">Jaunumi</h1>)
        }
        
        <List
          className="row"
          items={parent? items.filter(i => i.id !== parent).slice(0, 5) : items}
          {...props}
          renderItem={this.renderItem}
          onLoadMoreClick={!parent ? this.handleLoadMoreClick : null}
        />
      </div>
    );
  }
};

const mapStateTopProps = (state, props) => ({
  items: state.pagination.news.ids.map(i => selectHydrated(state, i)),
  ...state.pagination.news
});

export default connect(
  mapStateTopProps,
  { loadNewsPage }
)(NewsIndex);


// WEBPACK FOOTER //
// ./src/scenes/News/NewsIndex.js